class BookingController {
    constructor($state, cacheService) {
        'ngInject';
        this.$state = $state;
        this.cacheService = cacheService;
        this.name = 'booking';
    }
}

export default BookingController;



// WEBPACK FOOTER //
// ./client/app/routes/onTheBeach/booking/booking.controller.js